import type { PlanTiers } from "@/react/helpers/planHelpers";

import { PlanFeature } from "../PlanSelector/PlanFeature";
import { getTierHighlights } from "../PlanSelector/tierHighlights";

interface FeaturesListProps {
  isOnOffer: boolean;
  planTier: PlanTiers;
  shouldHighlightFeatures: boolean;
}

export const FeaturesList = ({
  planTier,
  isOnOffer,
  shouldHighlightFeatures,
}: FeaturesListProps) => {
  const features = getTierHighlights()[planTier];
  return (
    <>
      {features.map(feature => (
        <PlanFeature
          key={feature.text}
          feature={feature.text}
          isOnOffer={isOnOffer}
          isHighlighted={shouldHighlightFeatures}
          highlightColor={feature.highlightColor}
          highlightIcon={feature.highlightIcon}
          color={feature.color}
          fontWeight={feature.fontWeight}
        />
      ))}
    </>
  );
};
